<template>
  <form
    method="post"
    @submit.prevent="$emit('submit', formData)"
  >
    <h3>
      {{ $t('phrase.register_research') }}
      <small class="text-muted">{{ $t('word.general_info').toLowerCase() }}</small>
    </h3>

    <div class="card card-body mb-2">
      <div class="row">
        <div class="col-md-6">
          <div class="h-100 d-flex justify-content-center align-items-center mb-5">
            <v-youtube
              v-if="formData.youtube_id"
              :video-id="formData.youtube_id"
              player-width="300px"
              player-height="150px"
              ref="youtube"
              @ready="setVideoTitle()"
            />
            <img
              v-else
              class="img-research-form"
              src="@/common/assets/img/youtube.png"
              alt="commercialreview"
            />
          </div>
        </div>
        <div class="col-md-6">
          <h4>
            <small>
              <i class="fa fa-circle text-cr-red-black"></i>
            </small>

            {{ $t('phrase.youtube_id') }}
          </h4>
          <form
            method="post"
            @submit.prevent="processYouTubeId"
          >
            <p class="text-muted">
              {{ $t('sentence.research_youtube_fill_in') }}
            </p>
            <div class="mb-3">
              <v-text-input
                v-model="youtubeUrlOrId"
                :errors="errors.youtube_id"
                placeholder="sentence.commercial_url_fill_in"
                :disabled="!!formData.youtube_id"
              />
            </div>
            <div
              v-if="!youtubeLoaded && !research"
              class="d-flex justify-content-end"
            >
              <v-button
                text="phrase.save_and_next"
                type="submit"
                style-type="secondary"
                :loader="loader"
                :disabled="!youtubeUrlOrId"
              />
            </div>
          </form>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div
        class="card card-extra-info mb-2"
        v-if="formData.youtube_id"
      >
        <div class="card-body">
          <v-research-form
            :form-data="formData"
            :allow-created-by="allowCreatedBy"
            :allow-published="true"
            :allow-categories="true"
            :errors="errors"
          />
        </div>

        <div class="card-footer d-flex justify-content-end">
          <v-button
            text="phrase.save_and_next"
            id="research-form-submit"
            icon="fa fa-arrow-right"
            type="submit"
            style-type="primary"
            :loader="loader"
          />
        </div>
      </div>
    </transition>
  </form>
</template>

<script>
import TextInput from '@/common/components/inputs/TextInput.vue';
import Button from '@/common/components/Button.vue';
import {
  getIdFromURL,
  YouTubePlayer,
} from 'vue-youtube-embed';
import { fetchCommercialCategories } from '@/organisation/api';
import { mapGetters } from 'vuex';
import ResearchForm from '@/common/components/research/ResearchForm.vue';

export default {
  name: 'ResearchFormTv',
  components: {
    'v-text-input': TextInput,
    'v-research-form': ResearchForm,
    'v-button': Button,
    'v-youtube': YouTubePlayer,
  },
  props: {
    allowCreatedBy: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    research: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      errors: {},
      youtubeUrlOrId: null,
      youtubeLoaded: false,
      loader: { loading: false },
      categories: null,
      formData: {
        youtube_id: '',
        title: '',
        description: '',
        organisation: null,
        published_at: null,
        categories: [],
        group_size: 250,
        created_by_name: '',
      },
    };
  },
  computed: {
    ...mapGetters(['org']),
  },
  methods: {
    async getCommercialCategories() {
      const response = await fetchCommercialCategories();
      this.categories = response.data.map((el) => ({
        id: el.id,
        name: el.name,
      }));
    },
    processYouTubeId() {
      this.loader.loading = true;
      const youtubeId = getIdFromURL(this.youtubeUrlOrId);
      if (youtubeId) {
        this.formData.youtube_id = youtubeId;
      } else {
        this.loader.loading = false;
      }
    },
    setVideoTitle() {
      if (this.research) {
        this.loader.loading = false;
        return;
      }
      this.errors.youtube_id = [];
      const { title } = this.$refs.youtube.player.getVideoData();
      if (!title) {
        this.errors.youtube_id = [this.$t('phrase.youtube_id_invalid')];
        this.formData.youtube_id = '';
        this.loader.loading = false;
        this.$emit('invalid-form');
        return;
      }
      this.formData = { ...this.formData, ...{ title } };
      this.loader.loading = false;
      this.youtubeLoaded = true;
    },
  },
  created() {
    this.getCommercialCategories();

    if (this.research) {
      const youtubeId = this.research.commercial ? this.research.commercial.youtube_id : null;
      if (youtubeId) {
        setTimeout(
          () => {
            this.youtubeUrlOrId = `https://www.youtube.com/watch?v=${youtubeId}`;
            this.processYouTubeId();
          },
          50,
        );
      }

      this.formData = {
        youtube_id: youtubeId,
        title: this.research.title,
        description: this.research.description,
        organisation: this.research.organisation,
        categories: this.research.commercial.categories,
        published_at: new Date(this.research.commercial.published_at),
        group_size: this.research.group_size,
      };
    }
  },
};
</script>
